(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trenwick-work-socks"] && !Shopify.designMode) return;
  try {
    
function initializeSockPage(root) {
  if (root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const formatter = new Intl.NumberFormat('en-AU', {style:'currency',currency:'AUD'});
  const form = root.querySelector('.ts-form');
  const button = root.querySelector('[data-add-button]');
  const initialLabel = root.querySelector('[data-cta-label]')?.textContent;
  root.querySelectorAll('.ts-packs input').forEach(input => input.addEventListener('change', () => {
    root.querySelectorAll('[data-cta-price],[data-sticky-price]').forEach(el => el.textContent = formatter.format(Number(input.dataset.price)/100));
    if (form) form.querySelector('[data-variant-input]').value = input.value;
    if (button) button.disabled = input.dataset.available !== 'true';

  }));
  const imageData = {
    '1': {asset:'trenwick-sock-reference-single.png',className:'ts-picture--single'},
    '3': {asset:'trenwick-sock-reference-three.png',className:'ts-picture--three'},
    '6': {asset:'trenwick-sock-reference-six.png',className:'ts-picture--six'}
  };
  const originalImage = root.querySelector('.ts-picture img').src;
  root.querySelectorAll('[data-photo]').forEach(tab=>tab.addEventListener('click',()=>{
    const data=imageData[tab.dataset.photo];
    const frame=root.querySelector('.ts-picture');
    const img=frame.querySelector('img');
    img.src=tab.dataset.src;
    frame.className='ts-picture '+data.className;
    root.querySelectorAll('[data-photo]').forEach(other=>{other.classList.toggle('is-selected',other===tab);other.setAttribute('aria-pressed',String(other===tab));});
  }));
  if (form) {
    const id=form.querySelector('[data-variant-input]').value;
    const matching=Array.from(root.querySelectorAll('.ts-packs input')).find(i=>i.value===id);
    if (matching) {matching.checked=true;matching.dispatchEvent(new Event('change'));}
    form.addEventListener('submit',async event=>{
      event.preventDefault(); if(button.disabled)return; button.disabled=true;
      const status=root.querySelector('.ts-form-status');status.textContent='';
      try {
        const response=await fetch(root.dataset.cartUrl,{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
        const result=await response.json();
        if(!response.ok)throw new Error(result.description||result.message||'Please try again.');
        window.location.assign('/cart');
      } catch(error) {status.textContent=error.message;button.disabled=false;root.querySelector('[data-cta-label]').textContent=initialLabel;}
    });
  }
}
document.querySelectorAll('[data-sock-page]').forEach(initializeSockPage);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-sock-page]').forEach(initializeSockPage));

  } catch(e) { console.error(e); }
})();
})();
